
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[...slug]",
      function () {
        return require("private-next-pages/destination/[...slug]/index.tsx");
      }
    ]);
  